export function fetchFontAsset(url) {
  if (typeof document === "undefined") {
    return;
  }

  const linkElement = document.createElement("link");
  linkElement.rel = "stylesheet";
  linkElement.href = url;
  document.head.appendChild(linkElement);
}

export const GTagEvents = {
  SendMessage: "message_sent",
  OpenChatbot: "chatbot_opened",
  StartConversation: "conversation_started",
  NewSession: "new_session",
  PageLoadedWithChatbot: "page_loaded_with_chatbot",
};

export const LocalStorageKeys = {
  SessionId: "br_session",
  UserId: "br_user",
};
